import { getSupabaseUrl } from "@/lib/publicSupabaseConfig";

const SENSITIVE_QUERY_KEYS = new Set([
  "access_token",
  "refresh_token",
  "token",
  "code",
  "password",
  "secret",
  "state",
  "error_description",
]);

const getSupabaseHost = () => {
  try {
    const url = getSupabaseUrl();
    return url ? new URL(url).hostname : null;
  } catch {
    return null;
  }
};

export function sanitizeLogUrl(input: string | null | undefined) {
  if (!input) return null;

  try {
    const url = new URL(input, window.location.origin);
    url.hash = "";
    for (const key of Array.from(url.searchParams.keys())) {
      const normalized = key.toLowerCase();
      if (
        SENSITIVE_QUERY_KEYS.has(normalized) ||
        normalized.includes("token") ||
        normalized.includes("secret") ||
        normalized.includes("password")
      ) {
        url.searchParams.set(key, "[redacted]");
      }
    }
    return `${url.pathname}${url.search}${url.origin === window.location.origin ? "" : ` @ ${url.origin}`}`;
  } catch {
    return input.split("#")[0].slice(0, 500);
  }
}

export function isSafeAttachmentUrl(input: string | null | undefined) {
  if (!input) return false;

  try {
    const url = new URL(input);
    if (url.protocol !== "https:") return false;

    const supabaseHost = getSupabaseHost();
    if (!supabaseHost || url.hostname !== supabaseHost) return false;

    return url.pathname.startsWith("/storage/v1/object/");
  } catch {
    return false;
  }
}

export function openSafeAttachmentUrl(input: string | null | undefined) {
  if (!isSafeAttachmentUrl(input)) return false;
  window.open(input!, "_blank", "noopener,noreferrer");
  return true;
}
